// Importing necessary types
import {
  ILeaveService,
  IAvailableCompOffs,
  ILeaveTypeServiceResponse,
  IApplyLeaveFormData,
} from "../../../features/leave/types";
import { IBaseResponse } from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

enum LeaveEndpoints {
  LEAVE_DETAILS = "/employee/leave",
  LEAVE_COMP_OFF = "/employee/leave/available-compoff",
  APPLY_LEAVE = "/employee/leave/apply",
  LEAVE_TYPE = "/employee/leave/type",
}

// Define the LeaveService class that extends ApiService to handle leave-related API requests
class LeaveService extends ApiService {
  // Method to fetch leave details for a user for a specific year
  async getLeaveDetails(
    activeYear: number,
    userId?: string
  ): Promise<ILeaveService> {
    return this.get<ILeaveService>(
      `${LeaveEndpoints.LEAVE_DETAILS}/${userId}?active_year=${activeYear}`
    );
  }

  // Method to fetch available comp off details for the current user
  async getAvailableCompOffs(userId: number): Promise<IAvailableCompOffs> {
    return this.get<IAvailableCompOffs>(
      `${LeaveEndpoints.LEAVE_COMP_OFF}/${userId}`
    );
  }

  // Method to apply for leave for a user
  async applyLeaveUser(
    leaveFormData: IApplyLeaveFormData
  ): Promise<IBaseResponse> {
    return this.post<IBaseResponse>(LeaveEndpoints.APPLY_LEAVE, leaveFormData);
  }

  async getLeaveTypes({
    userId,
    activeYear,
  }: {
    userId?: number;
    activeYear?: string;
  }): Promise<ILeaveTypeServiceResponse> {
    // Sending GET request to fetch all leave types
    return this.get<ILeaveTypeServiceResponse>(
      `${LeaveEndpoints.LEAVE_TYPE}/${userId}?active_year=${activeYear}`
    );
  }
}

// Create an instance of LeaveService and export it for use in other parts of the application
export const leaveService = new LeaveService();
